import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-back",
  "use": "icon-back-usage",
  "viewBox": "0 0 128 128",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" viewBox=\"0 0 128 128\" id=\"icon-back\">\n<path d=\"M79.06,25.72l1.89,1.89c1.04,1.04,1.04,2.73,0,3.77L48.33,64l32.62,32.62c1.04,1.04,1.04,2.73,0,3.77l-1.89,1.89\n\tc-1.04,1.04-2.73,1.04-3.77,0L38.9,65.89c-1.04-1.04-1.04-2.73,0-3.77l36.39-36.39C76.33,24.68,78.02,24.68,79.06,25.72z\" />\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol